module.exports = __webpack_public_path__ + "img/tu1.5f1e888a.png";